export default __webpack_public_path__ + "static/media/bank-transfer-highlight.c94054e4.png";